<template>
    <v-container>
        <h1>Orders</h1>
        <v-row justify='center' class='mt-15' v-if='false'>
            <v-col lg=8>
                <v-img :src="require('../assets/under_construction.svg')" contain/>
                <h2 class='text-center mt-10 font-weight-regular'> Coming Soon!</h2>
            </v-col>  
        </v-row>
        <h3>Active Orders</h3>
        <v-row>
            <v-col lg=12> 
                <v-data-table
                    :headers="active_headers"
                    :items="active_orders"
                    :items-per-page="itemsPerPage"
                    :server-items-length="totalItems"
                    class="elevation-1"
                    @update:page="updatePage"
                    @update:items-per-page="updateItemsPerPage"
                    @update:sort-by="updateSortBy"
                    @update:sort-desc="updateSortDesc"
                ></v-data-table>
            </v-col>
        </v-row>

        <h3 class='mt-15'>Past Orders</h3>
        <v-row>
            <v-col lg=12> 
                <v-data-table
                    :headers="past_headers"
                    :items="past_orders"
                    :items-per-page="5"
                    class="elevation-1"
                ></v-data-table>
            </v-col>  
        </v-row>

    </v-container>
</template>
<script>
/*global myBaseURL*/
import axios from 'axios';


export default {
    name:'Orders',
    data () {
      return {
        active_headers: [
            {
                text: 'Order Id',
                align: 'start',
                sortable: false,
                value: 'id',
            },
            { text: 'Order Placed on', value: 'placed_on' },
            { text: 'Order Placed by', value: 'customer_name' },
            { text: 'Order Amount', value: 'bill_total' },
            { text: 'Status', value: 'status' },
        ],

        past_headers: [
            {
                text: 'Order Id',
                align: 'start',
                sortable: false,
                value: 'id',
            },
            { text: 'Order Placed on', value: 'placed_on' },
            { text: 'Order Placed fulfilled on', value: 'delivered_on' },
            { text: 'Order Placed by', value: 'customer_name' },
            { text: 'Order Amount', value: 'bill_total' },
            { text: 'Status', value: 'status' },
        ],
        active_orders: [],
        past_orders: [],
        currentPage : 1,
        itemsPerPage : 5,
        totalItems : 0,
        sortDesc : false,
        sortBy : 'id'
      }
      },
    created(){
        this.$emit('showLogout',true);
        this.$emit('showNavDrawer',true);
        axios.request({
            url: '/merchants/orders/' + this.$route.params.store_slug + '?page=' + this.currentPage + '&limit=' + this.itemsPerPage + '&orderType=active',
            method: 'GET',
            baseURL: myBaseURL,
            headers: {
                'Authorization': 'Bearer '+ window.localStorage.access_token
            }
        }).then(response =>{
            console.log(response)
            this.totalItems = response.data.total
            this.active_orders=response.data.data
        })

        axios.request({
            url: '/merchants/orders/' + this.$route.params.store_slug + '?page=' + this.currentPage + '&limit=' + this.itemsPerPage+ '&orderType=past',
            method: 'GET',
            baseURL: myBaseURL,
            headers: {
                'Authorization': 'Bearer '+ window.localStorage.access_token
            }
        }).then(response =>{
            console.log(response)
            this.past_orders=response.data.data
        })
    },
    methods: ({
        updatePage(data){
            this.currentPage = data;
            axios.request({
                url: '/merchants/orders/' + this.$route.params.store_slug + '?page=' + this.currentPage + '&limit=' + this.itemsPerPage + '&sortBy=' + this.sortBy + '&sortDesc=' + this.sortDesc,
                method: 'GET',
                baseURL: myBaseURL,
                headers: {
                    'Authorization': 'Bearer '+ window.localStorage.access_token
                }
            }).then(response =>{
                this.active_orders=response.data.data
                this.totalItems = response.data.total
            })
        },
        updateItemsPerPage(data)
        {
            this.itemsPerPage = data;
            // console.log(data);
            axios.request({
                url: '/merchants/orders/' + this.$route.params.store_slug + '?page=' + this.currentPage + '&limit=' + this.itemsPerPage + '&sortBy=' + this.sortBy + '&sortDesc=' + this.sortDesc,
                method: 'GET',
                baseURL: myBaseURL,
                headers: {
                    'Authorization': 'Bearer '+ window.localStorage.access_token
                }
            }).then(response =>{
                this.active_orders=response.data.data
                this.totalItems = response.data.total
            })
        },
        updateSortBy(data){
            console.log(data);
            this.sortBy = data[0];
            axios.request({
                url: '/merchants/orders/' + this.$route.params.store_slug + '?page=' + this.currentPage + '&limit=' + this.itemsPerPage + '&sortBy=' + this.sortBy + '&sortDesc=' + this.sortDesc,
                method: 'GET',
                baseURL: myBaseURL,
                headers: {
                    'Authorization': 'Bearer '+ window.localStorage.access_token
                }
            }).then(response =>{
                this.active_orders=response.data.data
                this.totalItems = response.data.total
            })
        },
        updateSortDesc(data)
        {
            this.sortDesc = data[0];
            // console.log(data);
            axios.request({
                url: '/merchants/orders/' + this.$route.params.store_slug + '?page=' + this.currentPage + '&limit=' + this.itemsPerPage + '&sortBy=' + this.sortBy + '&sortDesc=' + this.sortDesc,
                method: 'GET',
                baseURL: myBaseURL,
                headers: {
                    'Authorization': 'Bearer '+ window.localStorage.access_token
                }
            }).then(response =>{
                this.active_orders=response.data.data
                this.totalItems = response.data.total
            })
        }
    })
}
</script>